import styled from 'styled-components';

import { Card } from '../../../../../../../components/ToolkitV2/CardV2/Card';
import { SkeletonBlock } from '../../../../../../../components/ToolkitV2/Skeleton/Skeleton';

import { media } from '../../../../../../../helpers/breakpoints';

const CARD_HEIGHT = '100px';
const IMAGE_WIDTH_MOBILE = '116px';
const IMAGE_WIDTH_DESKTOP = '180px';

const StyledAdCard = styled(Card)`
  border-radius: ${({ theme }) => theme.borderRadius.default};
  overflow: hidden;
  height: ${CARD_HEIGHT};
`;

const AdCardImage = styled.img`
  width: ${IMAGE_WIDTH_MOBILE};
  max-width: ${IMAGE_WIDTH_MOBILE};
  height: ${CARD_HEIGHT};
  object-fit: cover;
  object-position: 50% 50%;

  ${media.medium} {
    width: ${IMAGE_WIDTH_DESKTOP};
    max-width: ${IMAGE_WIDTH_DESKTOP};
  }
`;

const FallbackImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${IMAGE_WIDTH_MOBILE};
  height: ${CARD_HEIGHT};
  background-color: ${({ theme }) => theme.colors.GREY_LIGHTER};

  ${media.medium} {
    width: ${IMAGE_WIDTH_DESKTOP};
  }
`;

const ImageSkeleton = styled(SkeletonBlock)`
  border-radius: 0;
`;

export { StyledAdCard, AdCardImage, FallbackImageContainer, ImageSkeleton };
